module.exports = __webpack_public_path__ + "3edd4374b35ea23c1b5c559b62c34fe4.MP3";